module.exports = __webpack_public_path__ + "img/avatar-35.8aa9b217.png";